<div class="container-fluid">
  <div class="row">
    <div
      class="d-flex justify-content-between flex-wrap gap-2 align-items-center mb-3"
    >
      <h5 class="d-flex mb-0 align-items-center">
        <button
          type="button"
          class="d-flex btn btn-link p-0 me-1"
          (click)="goBack()"
          data-bs-toggle="tooltip"
          title="{{ 'COMMON.BACK' | translate }}"
        >
          <mat-icon color="primary" class="me-2">arrow_back</mat-icon>
        </button>
        <mat-icon color="primary" class="me-2">history</mat-icon>
        <p class="wrap-text mb-0 d-flex align-items-center">
          {{
            showErrorDetails
              ? ("UPLOAD_LOGS.ERROR_DETAILS" | translate)
              : ("UPLOAD_LOGS.TITLE" | translate)
          }}
        </p>
      </h5>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0 d-flex align-items-center">
              <span>
                {{
                  showErrorDetails
                    ? ("UPLOAD_LOGS.ERROR_DETAILS" | translate)
                    : ("UPLOAD_LOGS.TITLE" | translate)
                }}
              </span>
            </h5>

            <button
              *ngIf="showErrorDetails"
              type="button"
              mat-stroked-button
              color="primary"
              (click)="backToHistory()"
            >
              <mat-icon class="me-1">arrow_back</mat-icon>
              {{ "UPLOAD_LOGS.BACK_TO_HISTORY" | translate }}
            </button>
          </div>
        </div>

        <div class="card-body">
          <!-- Alert Messages -->
          <p *ngIf="form['error'] == false && form['message']">
            <app-ncs-alert [message]="form['message']" type="success" />
          </p>
          <p *ngIf="form['error'] == true && form['message']">
            <app-ncs-alert [message]="form['message']" type="danger" />
          </p>

          <!-- UPLOAD HISTORY TABLE -->
          <div *ngIf="!showErrorDetails">
            <div class="mb-3">
              <button
                type="button"
                mat-stroked-button
                color="warn"
                (click)="deleteAllSelectedLogs()"
              >
                <mat-icon class="icon-compact">delete</mat-icon>
                {{ "UPLOAD_LOGS.DELETE_SELECTED" | translate }}
              </button>
            </div>
            <div class="table-container mb-2">
              <div class="table-responsive table-scrollable">
                <table
                  class="table table-hover table-bordered table-sticky-header"
                >
                  <thead>
                    <tr>
                      <th class="text-center">
                        <mat-checkbox
                          [(ngModel)]="masterSelectedLogs"
                          (change)="selectAllLogs()"
                          color="primary"
                          aria-label="Select all logs"
                        >
                        </mat-checkbox>
                      </th>
                      <th class="text-center">
                        {{ "UPLOAD_LOGS.TABLE.SNO" | translate }}
                      </th>
                      <th>{{ "UPLOAD_LOGS.TABLE.FILE_NAME" | translate }}</th>
                      <th>{{ "UPLOAD_LOGS.TABLE.DATE" | translate }}</th>
                      <th>{{ "UPLOAD_LOGS.TABLE.TOTAL_ROWS" | translate }}</th>
                      <th>{{ "UPLOAD_LOGS.TABLE.SUCCESS" | translate }}</th>
                      <th>{{ "UPLOAD_LOGS.TABLE.ERRORS" | translate }}</th>
                      <th>{{ "UPLOAD_LOGS.TABLE.STATUS" | translate }}</th>
                      <th>{{ "UPLOAD_LOGS.TABLE.ACTION" | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let log of uploadLogs; let i = index">
                      <td class="text-center">
                        <mat-checkbox
                          [(ngModel)]="log.selected"
                          (change)="checkIfAllLogsSelected()"
                          color="primary"
                        >
                        </mat-checkbox>
                      </td>
                      <td class="text-center">{{ pageIndex(i) }}</td>
                      <td>{{ log.fileName }}</td>
                      <td>
                        {{ log.createdDatetime | date: "dd MMM yyyy, hh:mm a" }}
                      </td>
                      <td>{{ log.totalRows }}</td>
                      <td>
                        <span class="badge bg-success text-white">
                          {{ log.successRows }}
                        </span>
                      </td>
                      <td>
                        <span class="badge bg-danger text-white">
                          {{ log.errorRows }}
                        </span>
                      </td>
                      <td class="text-center">
                        <span
                          class="badge"
                          [ngClass]="{
                            'bg-success': log.status === 'Completed',
                            'bg-warning text-dark':
                              log.status === 'Completed with Errors',
                            'bg-danger': log.status === 'Failed',
                            'bg-secondary': log.status === 'Pending',
                          }"
                        >
                          {{ log.status }}
                        </span>
                      </td>
                      <td>
                        <div class="d-flex gap-1">
                          <button
                            *ngIf="log.errorRows > 0"
                            type="button"
                            mat-stroked-button
                            color="primary"
                            (click)="viewErrors(log.id)"
                            matTooltip="{{
                              'UPLOAD_LOGS.ACTIONS.VIEW_ERRORS' | translate
                            }}"
                            matTooltipPosition="above"
                          >
                            <mat-icon>visibility</mat-icon>
                            <span class="d-none d-md-inline">{{
                              "UPLOAD_LOGS.ACTIONS.VIEW_ERRORS" | translate
                            }}</span>
                          </button>

                          <button
                            *ngIf="log.errorRows === 0"
                            type="button"
                            mat-stroked-button
                            disabled
                          >
                            <mat-icon>visibility_off</mat-icon>
                            <span class="ms-1 d-none d-md-inline">{{
                              "UPLOAD_LOGS.ACTIONS.NO_ERRORS" | translate
                            }}</span>
                          </button>

                          <button
                            type="button"
                            mat-stroked-button
                            color="warn"
                            class="icon-width icon-center"
                            (click)="deleteLog(log.id)"
                            matTooltip="{{ 'COMMON.DELETE' | translate }}"
                            matTooltipPosition="above"
                          >
                            <mat-icon class="icon-compact">delete</mat-icon>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- Empty State -->
            <div *ngIf="uploadLogs.length === 0" class="text-center py-5">
              <i class="bi bi-inbox text-muted" style="font-size: 4rem"></i>
              <p class="text-muted mt-2">
                {{ "UPLOAD_LOGS.NO_HISTORY" | translate }}
              </p>
            </div>
            <app-list-header [$parent]="getSelf()"></app-list-header>
          </div>

          <!-- ERROR DETAILS TABLE -->
          <div *ngIf="showErrorDetails">
            <div class="mb-3">
              <button
                type="button"
                mat-stroked-button
                color="warn"
                (click)="deleteAllSelectedErrors()"
              >
                <mat-icon class="icon-compact">delete</mat-icon>
                {{ "UPLOAD_LOGS.DELETE_SELECTED" | translate }}
              </button>
            </div>
            <div class="table-container mb-2">
              <div class="table-responsive table-scrollable">
                <table
                  class="table table-bordered table-hover table-sticky-header"
                >
                  <thead>
                    <tr>
                      <th class="text-center">
                        <mat-checkbox
                          [(ngModel)]="masterSelectedErrors"
                          (change)="selectAllErrors()"
                          color="primary"
                        >
                        </mat-checkbox>
                      </th>
                      <th class="text-center">
                        {{ "UPLOAD_LOGS.TABLE.SNO" | translate }}
                      </th>
                      <th width="10%">
                        {{ "UPLOAD_LOGS.TABLE.ROW_NO" | translate }}
                      </th>
                      <th width="20%">
                        {{ "UPLOAD_LOGS.TABLE.COLUMN_NAME" | translate }}
                      </th>
                      <th width="22%">
                        {{ "UPLOAD_LOGS.TABLE.VALUE" | translate }}
                      </th>
                      <th width="35%">
                        {{ "UPLOAD_LOGS.TABLE.ERROR_MESSAGE" | translate }}
                      </th>
                      <th width="8%">
                        {{ "UPLOAD_LOGS.TABLE.ACTION" | translate }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let error of errorDetails; let i = index">
                      <td class="text-center">
                        <mat-checkbox
                          [(ngModel)]="error.selected"
                          (change)="checkIfAllErrorsSelected()"
                          color="primary"
                        >
                        </mat-checkbox>
                      </td>

                      <td class="text-center">{{ pageIndex(i) }}</td>
                      <td>
                        <span class="badge bg-secondary">{{
                          error.rowNumber
                        }}</span>
                      </td>
                      <td>
                        <strong>{{ error.columnName }}</strong>
                      </td>
                      <td>
                        <code class="text-muted">{{ error.value || "-" }}</code>
                      </td>
                      <td>
                        <span class="text-muted">{{ error.errorMessage }}</span>
                      </td>
                      <td>
                        <button
                          type="button"
                          mat-stroked-button
                          color="warn"
                          class="icon-center icon-width"
                          (click)="deleteErrorDetail(error.id)"
                          matTooltip="{{ 'COMMON.DELETE' | translate }}"
                          matTooltipPosition="above"
                        >
                          <mat-icon class="icon-compact">delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- Empty State -->
            <div *ngIf="errorDetails.length === 0" class="text-center py-5">
              <i
                class="bi bi-check-circle-fill text-success"
                style="font-size: 4rem"
              ></i>
              <p class="text-muted mt-2">
                {{ "UPLOAD_LOGS.NO_ERRORS" | translate }}
              </p>
            </div>

            <app-list-header [$parent]="getSelf()"></app-list-header>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>